import { ValidationErrors } from '@/entities/validation';

export type ParsedError = {
  code: number;
  parsed: unknown;
};

export class ApiError {
  public code: number;

  public message: string;

  public messages: ValidationErrors;

  constructor(code: number, message: string, messages: ValidationErrors = []) {
    this.code = code;
    this.message = message;
    this.messages = messages;
  }
}

export * from './decoder';
export * from './parse';
export * from './transform';
